/* jshint esnext: true */
import { APP_NAME, isDebug, $document } from '../utils/environment';
import AbstractModule from './AbstractModule';
import * as CookieConsent from 'vanilla-cookieconsent';

const DEBUG = false; // isDebug

const MODULE_NAME = 'Example';
const EVENT_NAMESPACE = `${APP_NAME}.${MODULE_NAME}`;

const EVENT = {
    CLICK: `click.${EVENT_NAMESPACE}`
};

export default class extends AbstractModule {
    constructor(options) {
        super(options);

        // Declaration of properties
        DEBUG && console.log('🔨 [module]:constructor - Example');

        this.$el = options.$el;
        var opts = this.$el.attr('data-cookie-consent-options');

        try {
            this.cookieConfig = JSON.parse(opts);
        } catch (e) {
            console.warn(e.message);
        }

        this.cookieConfig.categories = this.prepareCategories(this.cookieConfig.categories);
        this.cookieConfig.onConsent = () => {
            this.toggleCategoryAnalytics();
            this.toggleCategoryTargeting();
        };
        this.cookieConfig.onChange = ({ changedCategories }) => {
            if (changedCategories.includes('analytics')) {
                this.toggleCategoryAnalytics();
            }

            if (changedCategories.includes('targeting')) {
                this.toggleCategoryTargeting();
            }
        };

        CookieConsent.run(this.cookieConfig);
    }

    prepareCategories(categories) {
        for (const [categoryName, categoryData] of Object.entries(categories)) {
            if (
                categoryData?.autoClear?.cookies &&
                Array.isArray(categoryData.autoClear.cookies) &&
                categoryData.autoClear.cookies.length > 0
            ) {
                categoryData.autoClear.cookies.map((cookie) => {
                    if (
                        cookie?.name &&
                        typeof cookie.name === 'string'
                    ) {
                        const found = cookie.name.match(/^\/(.+)\/([a-z]+)?$/);
                        if (found) {
                            cookie.name = new RegExp(found[1], found[2]);
                        }
                    }

                    return cookie;
                });

                categories[categoryName].autoClear.cookies = categoryData.autoClear.cookies;
            }
        }

        return categories;
    }

    toggleCategoryAnalytics() {
        const isAccepted = CookieConsent?.acceptedCategory('analytics');

        const consent = (isAccepted ? 'granted' : 'denied');

        if (typeof gtag === 'function') {
            gtag('consent', 'update', {
                'analytics_storage': consent,
            });
        }
    }

    toggleCategoryTargeting() {
        const isAccepted = CookieConsent?.acceptedCategory('targeting');

        const consent = (isAccepted ? 'granted' : 'denied');

        if (typeof gtag === 'function') {
            gtag('consent', 'update', {
                'ad_personalization': consent,
                'ad_storage':         consent,
                'ad_user_data':       consent,
            });
        }
    }

    init() {
        // Set events and such
        $document.on('click', '[href="#show-cookie-consent"]', event => {
            event.preventDefault();
            event.stopPropagation();
            CookieConsent.showPreferences();
        });

        this.$el.on('click', '[data-cookie-consent="hide"]', (event) => {
            CookieConsent.hide();
            CookieConsent.hidePreferences();
        });
    }

    destroy() {
        DEBUG && console.log('❌ [module]:destroy - Example');
        super.destroy();
        this.$el.off(`.${EVENT_NAMESPACE}`);
    }
}
